<template>
  <div class="loginbody" >
    <div class="logindata">
      <div class="logintext">
        <h2>Welcome</h2>
      </div>
      <div class="formdata">
        <el-form ref="login" :model="form" :rules="rules" >
          <el-form-item prop="account">
            <el-input
              v-model="form.account"
              clearable
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="form.password"
              clearable
              placeholder="请输入密码"
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="tool">
        <div>
          <el-checkbox v-model="checked" @change="remenber"
            >记住密码</el-checkbox
          >
        </div>
        <div>
          <span class="shou" @click="forgetpas">忘记密码？</span>
        </div>
      </div>
      <div class="butt">
        <el-button type="primary" @click="login">登录</el-button
        >
        <el-button class="shou" @click="registerBtn">注册</el-button>
      </div>
    </div>
    
  </div>
</template>

<script>



export default {
  components:{
      
  },
  name: "login",
  data() {
    return {
      form: {
        account: "",
        password: "",
      },
      checked: false,
      rules: {
        account: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          // { max: 10, message: "不能大于10个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          // { max: 10, message: "不能大于10个字符", trigger: "blur" },
        ],
      },
      loading: false,
      activeIndex: '2',
      open: false,
      dataForm: {
            query: ''
      },
      tableData: [],
      fileContent: '',
      file: '',
      data: '',
    };
  },
  mounted() {
      if(localStorage.getItem("news")){
        this.form=JSON.parse(localStorage.getItem("news"))
        this.checked=true
      }
  },
  methods: {
    registerBtn(){
      this.$router.push('/Register')
    },
    login(){
      this.$refs.login.validate(valid => {
        if(valid){
          this.$axios.get('/user/user_login',{
            params:{               //将URL地址拼接参数的形式换成传入params对象的形式
              token: 'lijian',
              account: this.form.account,
              password: this.form.password,
              appName: '指纹头厂测管理系统',
            }
          }).then(res=>{   //这里使用箭头函数的形式
            if(res.data.code==200){
              let time = parseInt(new Date().getTime() / 1000);
              sessionStorage.setItem("time",time);
              this.global.userData = res.data.data;
              this.$message({
                message: "登录成功啦",
                type: "success",
                showClose: true,
              });
              this.$router.push('/home')
            }else{
              this.$message({
                message: res.data.msg,
                type: "error",
                showClose: true,
              });
            }
          })
        }
      });
    },
    remenber(data){
      this.checked=data
      if(this.checked){
          localStorage.setItem("news",JSON.stringify(this.form))
      }else{
        localStorage.removeItem("news")
      }
    },
    forgetpas() {
      this.$message({
        type:"info",
        message:"功能尚未开发额😥",
        showClose:true
      })
    },
  },
};
</script>

<style scoped>
.header {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 60px;
        font-size: 20px;
        color: #fff;
        background-color:white;
        display: flex;
        align-items: center;
}
.el-login-btn{
  margin-right:50px;

}
.loginbody {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  background-image: url("../assets/login2.jpeg");
  background-size: 100% 100%;
  background-position: center center;
  overflow: auto;
  background-repeat: no-repeat;
  position: fixed;
  line-height: 100%;
}

.logintext {

  margin-bottom: 20px;
  line-height: 50px;
  text-align: center;
  font-size: 30px;
  font-weight: bolder;
  color: white;
  text-shadow: 2px 2px 4px #000000;
}

.logindata {
  width: 400px;
  height: 300px;
  transform: translate(-50%);
  margin-left: 50%;
  margin-top: 150px;
}

.tool {
  display: flex;
  justify-content: space-between;
  color: #606266;
}

.butt {
  margin-top: 10px;
  text-align: center;
}

.shou {
  cursor: pointer;
  color: #606266;
}

</style>




// WEBPACK FOOTER //
// src/components/Login.vue